import React from 'react'
import PropTypes from 'prop-types'
import CheckoutFrame from '../components/CheckoutFrame'
import Button from 'src/components/common/Button'
import { CreditsDescription } from '../components/description-components'
import styles from './credits-checkout.scss'
import cn from 'classnames'
import LeftChevronIcon from 'src/assets/icons/left_chevron.svg'
import FolderIcon from 'src/assets/icons/folder-ico-green.svg'
import SvgIcon from 'src/components/common/SvgIcon'

import {
  clearCheckoutPendingResultNode,
  PurchaseWorkflowNode,
  setCheckoutModalOpen,
  setCheckoutPendingResultNode,
  setDefaultWorkflowNode,
  setOpenedTabReference,
  setStripeCheckoutTimeoutHandle
} from 'src/actions/stripeCheckout'
import {
  buildCheckoutURLForCreditsBundle,
  getCreditsConfigs,
  storeUTMDataByKey,
  STRIPE_CHECKOUT_TIMEOUT
} from 'services/stripe_checkout_configs'
import { connect } from 'react-redux'
import uuid from 'uuid'
import { fetchUserGQ } from 'src/actions/user'

class CreditsCheckout extends React.Component {
  creditBundles = getCreditsConfigs()

  constructor(props) {
    super(props)

    this.state = {
      selectedBundle: this.creditBundles[0]
    }
  }

  openStripeCheckoutTab() {
    const { reloadUser } = this.props
    const userReloadCallback = resp => {
      const user = resp?.data?.me
      if (user) {
        const utmCode = uuid.v4()
        storeUTMDataByKey(user.current_subscription, utmCode)
        const href = buildCheckoutURLForCreditsBundle(this.state.selectedBundle, user.id, utmCode)
        /* safari will block window.open in async calls, wrap it with setTimeout can get around it */
        /* short-turn solution: */
        /* https://stackoverflow.com/questions/20696041/window-openurl-blank-not-working-on-imac-safari */
        /* long-turn solution: */
        /* use promise instead of callback to handle network requests in src/sagas/api.js:apiWorker() */
        setTimeout(() => {
          const newTabRef = window.open(href, '_blank')
          this.props.setOpenedTabRef(newTabRef)
        }, 0)
      }
    }

    reloadUser(userReloadCallback)
  }

  render() {
    const items = this.creditBundles
    const {
      setTimeoutHandle,
      storePendingResultNode,
      clearCheckoutPendingResultNode,
      setModalOpen,
      setDefaultCheckoutNode
    } = this.props

    return (
      <CheckoutFrame
        left={
          <main className={styles['credits-main']}>
            <header>
              <h1>
                {this.props.showGoBack && (
                  <SvgIcon
                    className={styles['back-icon']}
                    width={20}
                    height={20}
                    icon={LeftChevronIcon}
                    padding="5px"
                    onClick={() => {
                      if (this.props.onGoBack) {
                        this.props.onGoBack()
                      }
                    }}
                  />
                )}
                Get more Smart Invites
              </h1>
            </header>
            <section className={styles['credits-detail-container']}>
              <section>
                <h3>
                  <SvgIcon width={20} height={20} icon={FolderIcon} padding="5px" />
                  Select credits quantity{' '}
                </h3>
                <section className={styles['sub-title']}>
                  <span>(Credits bought here will never expire)</span>
                </section>
                <section className={styles['bundle-grid']}>
                  {items.map((item, i) => {
                    return (
                      <div
                        key={i}
                        className={cn(styles['bundle-item'], {
                          [styles['selected']]: item.stripeId === this.state.selectedBundle.stripeId
                        })}
                        onClick={() => this.setState({ selectedBundle: item })}
                      >
                        <div>
                          <span className={styles['item-sub-total']}>{item.creditsNumber}</span>
                        </div>
                        <div>
                          <span className={styles['item-price-label']}>{item.priceLabel}</span>
                        </div>
                      </div>
                    )
                  })}
                </section>
              </section>
              <section>
                <section className={styles['price-summary']}>
                  <div className={styles['price-summary-item']}>
                    <span>Unit Price x Quantity </span>
                    <span>{this.state.selectedBundle?.formula}</span>
                  </div>
                  <div className={styles['price-summary-item']}>
                    <span>
                      <b>Total Price</b>
                    </span>
                    <span>
                      <b>{this.state.selectedBundle?.subTotalLabel}</b>
                    </span>
                  </div>
                </section>
                <section>
                  <Button
                    className={styles['purchase-button']}
                    onClick={() => {
                      this.openStripeCheckoutTab()
                      const nextNode = PurchaseWorkflowNode.PendingCreditsPaymentResult
                      storePendingResultNode(nextNode)
                      setModalOpen(false)
                      const handle = setTimeout(() => {
                        clearCheckoutPendingResultNode()
                        setDefaultCheckoutNode(nextNode)
                        setModalOpen(true)
                      }, STRIPE_CHECKOUT_TIMEOUT)
                      setTimeoutHandle(handle)
                    }}
                  >
                    <span>PURCHASE</span>
                  </Button>
                </section>
              </section>
            </section>
          </main>
        }
        right={CreditsDescription()}
      />
    )
  }
}

CreditsCheckout.propTypes = {
  onGoBack: PropTypes.func,
  showGoBack: PropTypes.bool,
  setOpenedTabRef: PropTypes.func,
  setTimeoutHandle: PropTypes.func,
  storePendingResultNode: PropTypes.func,
  clearCheckoutPendingResultNode: PropTypes.func,
  setModalOpen: PropTypes.func,
  setDefaultCheckoutNode: PropTypes.func,
  reloadUser: PropTypes.func
}

const mapDispatchToProps = dispatch => {
  return {
    setOpenedTabRef: tabRef => {
      dispatch(setOpenedTabReference(tabRef))
    },
    reloadUser: successCallback => {
      dispatch(fetchUserGQ(successCallback))
    },
    setTimeoutHandle: handle => {
      dispatch(setStripeCheckoutTimeoutHandle(handle))
    },
    storePendingResultNode: pendingResultNode => {
      dispatch(setCheckoutPendingResultNode(pendingResultNode))
    },
    clearCheckoutPendingResultNode: () => {
      dispatch(clearCheckoutPendingResultNode())
    },
    setModalOpen: isOpen => dispatch(setCheckoutModalOpen(isOpen)),
    setDefaultCheckoutNode: node => {
      dispatch(setDefaultWorkflowNode(node))
    }
  }
}

export default connect(null, mapDispatchToProps)(CreditsCheckout)
